//=> Import React
import * as React from "react"

//=> import Images
import logoBerthe from "../../images/ImageBerthe.png"


//=> Import Styles
import { header, headerContent, image } from "./styles.module.scss"

//=> Component
const Header = () => {
  return (
    <header className={header}>
      <div className={`${headerContent}`}>
        <div className={image}>
          <img
            alt="Logo Berthe aux Paquerêttes"
            src={logoBerthe}
          />

        </div>
      </div>

    </header>
  )
}

export default Header